import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../chartTemplate";

const road_density_ChartFunc = (divRef, ndx) => {
    const road_density = ndx.dimension((d) => d.baseTbCode);
    //var road_density_grp = road_density.groupAll().reduceSum(function (d) {
    //    return d.road_Density;
    //});

    const all = ndx.groupAll().reduceSum((d) => d.road_Density).value();
    let total_road_density = all
    // custom reducer 
    const road_density_grp = road_density.groupAll().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.road_Density;
            p.avg += v.road_Density / p.count;
            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.road_Density;
            p.avg -= v.road_Density / p.count;
            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg:0};
        }
    );
    //define the dc chart object
  const road_density_Chart = dc.numberDisplay(divRef);
    road_density_Chart
        .dimension(road_density) // pass the road dimension  
        .formatNumber(d3.format(",.2f")) // format the values to 0 decimal place
        .group(road_density_grp) // define the groups for crossfilter
        .on("pretransition  ", function (chart) {
            chart.valueAccessor((d) => {
              
                let a = d.tot
              
                let b = total_road_density
                let record_count = d.count / 24 // the counties rows are dublicated 24 time 
                //console.log("b " + b)
                if (a < b && record_count == 1) {
                    //console.log("First if statement: " + a)
                    return a
                } else if (a < b && record_count > 1) {
                    return a / record_count
                } else if (a == b) {                    
                    return a / 47
                }
            });

        })
        .valueAccessor((d) => {
            
            return d.tot / 47; // use the value accessor to  define chart  data
        });

    return road_density_Chart; // return chart object

};

export const CRoadDensityChart = (props) => (
    // pass chart object as a prop to Chart  template for rendering
  <ChartTemplate chartFunction={road_density_ChartFunc} /> 
);

